import { useContext } from "react"
import { conffetiContext, OrdersContext, PopUpContext } from "../layout/Root"

export default function PayPopup({ order }) {
   const [, setPopUp] = useContext(PopUpContext)
   const [, setConffeti] = useContext(conffetiContext)
   const [, setTotalOrders] = useContext(OrdersContext)

   function onPay() {
      setPopUp()
      setConffeti(true)
      setTotalOrders(old => old.filter(o => o.info?._id !== order.info?._id))
   }

   return (
      <div>
         <h3>to pay : ${order?.orders?.reduce((prev, curr) => (curr.price * curr.amount) + prev, 0)}</h3>
         <h6>payment method:</h6>
         <button onClick={onPay} className='btn btn-light me-3'><img src="/img/visa.svg" width={60} alt="visa" /></button>
         <button onClick={onPay} className='btn btn-light'><img src="/img/paypal.svg" width={60} alt="paypal" /></button>
      </div>
   )
}